export const YES_NO_OPTIONS = [
  { value: "sim", label: "Sim" },
  { value: "nao", label: "Não" },
];

export const INITIAL_FORM = {
  name: "",
  surname: "",
  ibm: "",
  cpf: "",
  birthDate: "",
  email: "",
  phone: "",
  hasSpecialNeeds: "",
  specialNeedsDetails: "",
  hasHealthPlan: "",
  healthPlanName: "",
  companion: "",
  companionName: "",
  companionSurname: "",
  companionBirthDate: "",
  companionCpf: "",
  originCity: "",
  arrivalTime: "",
  bedPreference: "",
  dietaryRestrictions: "",
  dietaryDetails: "",
  hasAccessibilityNeeds: "",
  accessibilityDetails: "",
  acceptPrivacy: false,
};
